<template>
<div class="chapter">
<div class="inner_page">
<div class="acknowPage">
<div class="title-acknowPage"><a href="#/e9781429996211_toc01#toctitle1" id="title1"><span><strong class="b">ACKNOWLEDGMENTS</strong></span></a></div>
<div class="p"><span>I owe huge debts of inspiration to the following:
</span></div>
<br/><div class="blocktext"><div class="p-blocktext"><span>Cornelius Eady, who opened a door by approaching me with the idea of writing a play.</span></div>
<div class="p-blanc-blocktext"><span> <br/></span></div>
<div class="p-blocktext"><span>Sarah Stern, who followed through with this idea.</span></div>
<div class="p-blanc-blocktext"><span> <br/></span></div>
<div class="p-blocktext"><span>Tehching “Sam” Hsieh, the Taiwanese-born artist who spent a year (1981 to 1982) living outside in New York City (“The Outdoor Piece”).</span></div>
<div class="p-blanc-blocktext"><span> <br/></span></div>
<div class="p-blocktext"><span>Linda Montano, who spent a year (1983) tied by an eight-foot rope to Tehching Hsieh.</span></div>
<div class="p-blanc-blocktext"><span> <br/></span></div>
<div class="p-blocktext"><span>Deborah Ash (<em class="i">mwalimu</em>) and Hubert Sauper (<em class="i">rafiki</em>), who invited me to walk through Tanzania with them.</span></div>
<div class="p-blanc-blocktext"><span> <br/></span></div>
<div class="p-blocktext"><span>The amazing actors and directors of the staged readings, who offered invaluable insights.</span></div>
<div class="p-blanc-blocktext"><span> <br/></span></div>
<div class="p-blocktext"><span>Doug Montgomery, who shared his research into the syntax of the joke.</span></div>
<div class="p-blanc-blocktext"><span> <br/></span></div>
<div class="p-blocktext"><span>Esra Padgett, vernacular consultant and linguist extraordinaire.</span></div>
<div class="p-blanc-blocktext"><span> <br/></span></div>
<div class="p-blocktext"><span>Mel Chin, who urged me not to let people muscle me.</span></div>
<div class="p-blanc-blocktext"><span> <br/></span></div>
<div class="p-blocktext"><span>William Stafford, who pointed out that “the darkness around us is deep.”</span></div>
<div class="p-blanc-blocktext"><span> <br/></span></div>
<div class="p-blocktext"><span>Mark Subias and Denise Oswald, who shepherded this book into existence.</span></div></div><br/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781429996211_ack01.vue?e7cf875c